import AppModal from '@components/AppModal';
import Text from '@components/Text';
import colors from '@constants/colors';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useCloseInquiry from './hooks/useCloseInquiry';

interface Params {
    inquiryId: string;
}

declare module '@stackflow/config' {
    interface Register {
        CloseInquiryModal: Params;
    }
}

const CloseInquiryModal:ActivityComponentType<'CloseInquiryModal'> = ({ params }) => {
    const { t } = useTranslation('inquiry');
    const { inquiryId } = params;
    const closeInquiry = useCloseInquiry(inquiryId);
    return (
        <AppModal title={t('closeModal.title')}
            deny={t('closeModal.cancel')}
            confirm={t('closeModal.confirm')}
            onConfirm={closeInquiry} >
            <Text color={colors.gray6} align='center'>
                {t('closeModal.description')}
            </Text>
        </AppModal>
    );
};

export default CloseInquiryModal;
